import React, { memo } from "react";

const DividerLine = () => {
  const dashes = [
    { color: "#505050" },
    { color: "#FEDB02" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#049DDE" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#FEDB02" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#049DDE" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#FEDB02" },
    { color: "#049DDE" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },
    { color: "#505050" },

    // Add more colors as needed
  ];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {dashes.map((dash, index) => (
        <div
          key={index}
          style={{
            width: 20,
            height: 1,
            margin: "0 5px",
            background: dash.color,
          }}
        />
      ))}
    </div>
  );
};

export default memo(DividerLine);
